import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const KitchenGarden = () => {
  return (
    <>
      <Helmet>
        <title>Kitchen Garden | KRM Landscape</title>
        <meta
          name="description"
          content="KRM Landscape designs and installs kitchen gardens for homes, enabling fresh and organic vegetable cultivation."
        />
        <meta
          name="keywords"
          content="Kitchen Garden, Home Gardening, Organic Vegetables, KRM Landscape"
        />
      </Helmet>

      <ServiceLayout title="Kitchen Garden">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box
            component="img"
            src="/images/kitchengarden2.png"
            alt="Kitchen Garden by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </Box>

        <Typography paragraph>
          At KRM Landscape, our Kitchen Garden service helps you grow fresh,
          organic vegetables, herbs, and fruits right at your home. We design
          practical and sustainable kitchen gardens that fit perfectly into
          your available space whether it’s a backyard, terrace, balcony,
          or small urban area.
        </Typography>

        <Typography paragraph>
          Our experts carefully plan the garden layout, select seasonal and
          climate-appropriate crops, prepare nutrient-rich soil, and guide you
          through the complete setup process. We focus on creating gardens that
          are easy to maintain, highly productive, and suited to your daily
          cooking needs.
        </Typography>

        <Typography paragraph>
          From leafy greens and vegetables to herbs like basil, mint, coriander,
          and curry leaves, we ensure your kitchen garden remains healthy and
          pesticide-free. We also provide clear guidance on watering schedules,
          sunlight requirements, composting, and organic pest control.
        </Typography>

        <Typography paragraph>
          With a KRM Landscape Kitchen Garden, you don’t just grow food, you build
          a healthier lifestyle. Enjoy fresh harvests, reduced grocery costs,
          and the satisfaction of growing your own produce while adding greenery
          and freshness to your surroundings.
        </Typography>

      </ServiceLayout>
    </>
  );
};

export default KitchenGarden;
